<template>
  <v-container fluid class="pa-0">
    <app-stepper v-model="step" :steps="steps" />
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import { LessonsSteps } from "../stepsDefinition";
import Stepper from "./../components/Stepper.vue";

export default {
  components: {
    appStepper: Stepper,
  },
  data() {
    return {
      steps: LessonsSteps,
    };
  },
  computed: {
    step: {
      get() {
        return this.$store.getters["lesson/step"];
      },
      set(value) {
        return this.$store.commit("lesson/step", value);
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    this.step = 0;
    next();
  },
};
</script>
